define('plugin/promotion/model/PromotionOrderModel',['require','lib/model/BaseModel','plugin/invoice/model/InvoiceModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');

    /**
     * Promotion order data model
     *
     * @class PromotionPaymentModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/promotion/order/id/',

        defaults: {
            id: null,
            promotion_id: null,
            invoice: null,
            code: null
        },

        parse: function (resp, options) {
            var result = BaseModel.prototype.parse.apply(this, [resp, options]);
            if (result.invoice) {
                result.invoice = new InvoiceModel(result.invoice);
            }

            return result;
        }

    });

});
